import React, { useState } from "react";
import { Popover } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  container: {
    cursor: "pointer",
    borderBottom: "1px dotted #ccc",
    //    textDecoration: "underline dotted #ccc",
    "&:hover": {
      background: "yellow",
    },
  },
  popover: {
    maxWidth: 250,
    padding: 8,
    fontSize: "0.8em",
  },
}));

export default ({ meaning, m, original, o, children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  const handleClick = e => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = !!anchorEl;
  const id = open ? "explainer" : undefined;

  return (
    <span className={classes.container}>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <div className={classes.popover}>
          <div>
            <b>{children}</b>
          </div>
          <div>{meaning || m}</div>
          {(original || o) && <div>原形: {original || o}</div>}
        </div>
      </Popover>
      <span onClick={handleClick}>{children}</span>
    </span>
  );
};
